// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Subscription,
    SubscriptionFromJSON,
    SubscriptionToJSON,
    SubscriptionSchedule,
    SubscriptionScheduleFromJSON,
    SubscriptionScheduleToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaymentProfile
 */
export interface PaymentProfile {
    /**
     * 
     * @type {number}
     * @memberof PaymentProfile
     */
    id: number;
    /**
     * Stripe token returned by Stripe.js
     * @type {string}
     * @memberof PaymentProfile
     */
    stripeToken: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentProfile
     */
    users: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    billingCycle: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    stripeSubscriptionId?: string;
    /**
     * 
     * @type {SubscriptionSchedule}
     * @memberof PaymentProfile
     */
    subscriptionSchedule?: SubscriptionSchedule;
    /**
     * 
     * @type {Subscription}
     * @memberof PaymentProfile
     */
    subscription?: Subscription;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    declineCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentProfile
     */
    subscriptionCancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    subscriptionExpiration?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentProfile
     */
    country?: string;
    /**
     * (Zip/postal code)
     * @type {string}
     * @memberof PaymentProfile
     */
    postalCode?: string;
    /**
     * Tax ID - like European VAT number or Canadian BN or Canadian QST number
     * @type {string}
     * @memberof PaymentProfile
     */
    customerTaxId?: string;
}

export function PaymentProfileFromJSON(json: any): PaymentProfile {
    return {
        'id': json['id'],
        'stripeToken': json['stripe_token'],
        'users': json['users'],
        'billingCycle': json['billing_cycle'],
        'customerId': !exists(json, 'customer_id') ? undefined : json['customer_id'],
        'stripeSubscriptionId': !exists(json, 'stripe_subscription_id') ? undefined : json['stripe_subscription_id'],
        'subscriptionSchedule': !exists(json, 'subscription_schedule') ? undefined : SubscriptionScheduleFromJSON(json['subscription_schedule']),
        'subscription': !exists(json, 'subscription') ? undefined : SubscriptionFromJSON(json['subscription']),
        'declineCode': !exists(json, 'decline_code') ? undefined : json['decline_code'],
        'subscriptionCancelled': !exists(json, 'subscription_cancelled') ? undefined : json['subscription_cancelled'],
        'subscriptionExpiration': !exists(json, 'subscription_expiration') ? undefined : json['subscription_expiration'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'postalCode': !exists(json, 'postal_code') ? undefined : json['postal_code'],
        'customerTaxId': !exists(json, 'customer_tax_id') ? undefined : json['customer_tax_id'],
    };
}

export function PaymentProfileToJSON(value?: PaymentProfile): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'stripe_token': value.stripeToken,
        'users': value.users,
        'billing_cycle': value.billingCycle,
        'customer_id': value.customerId,
        'stripe_subscription_id': value.stripeSubscriptionId,
        'subscription_schedule': SubscriptionScheduleToJSON(value.subscriptionSchedule),
        'subscription': SubscriptionToJSON(value.subscription),
        'decline_code': value.declineCode,
        'subscription_cancelled': value.subscriptionCancelled,
        'subscription_expiration': value.subscriptionExpiration,
        'country': value.country,
        'postal_code': value.postalCode,
        'customer_tax_id': value.customerTaxId,
    };
}


